export interface RouterBackReturn {
  goBack: () => void
}

export function useRouterBack(): RouterBackReturn {
  const router = useRouter()

  const { $previousRoute } = useNuxtApp()
  const backPath = router?.options?.history?.state?.back

  async function goBack() {
    const previousRoute = $previousRoute as Ref<any>
    if (previousRoute?.value) {
      router.push(previousRoute.value)
    } else if (backPath) {
      if (typeof backPath === 'string') {
        await navigateTo(backPath, {
          replace: true,
        })
      } else router.back()
    } else {
      router.push('/')
    }
  }

  return {
    goBack,
  }
}
